import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Stack, Alert } from '@mui/material';
import { useUnit } from 'effector-react';
import { createCorpsFx } from '../../store/buildingCorps';

export default function AddCorpsDialog({ open, onClose, buildingId, onSuccess }) {
  const pending = useUnit(createCorpsFx.pending);
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) { setName(''); setError(''); }
  }, [open]);

  const canSubmit = name.trim().length > 0;

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    setError('');
    if (!canSubmit || pending) return;
    try {
      const { corps } = await createCorpsFx({ buildingId: String(buildingId), name: name.trim() });
      onSuccess?.(corps);
      onClose?.();
    } catch (err) {
      setError('Не удалось создать корпус. Проверьте данные и попробуйте снова.');
    }
  };

  return (
    <Dialog open={open} onClose={pending ? undefined : onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>Добавить корпус</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2} sx={{ mt: 1 }}>
            {error ? <Alert severity="error">{error}</Alert> : null}
            <TextField
              label="Название корпуса"
              placeholder="Например: Корпус 1"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
              required
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={pending}>Отмена</Button>
          <Button type="submit" variant="contained" disabled={!canSubmit || pending}>
            {pending ? 'Сохраняем…' : 'Создать'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
